'use client';

import type { AnimateLogoProps } from '../animate';

import { createPortal } from 'react-dom';
import { twMerge } from 'tailwind-merge';

import { AnimateLogoZoom, AnimateLogoZoomCSS } from '../animate';

// ----------------------------------------------------------------------

export type SplashScreenProps = React.ComponentProps<'div'> & {
  portal?: boolean;
  className?: string;
  slots?: {
    logo?: React.ReactNode;
  };
  slotProps?: {
    wrapper?: React.ComponentProps<'div'>;
    logo?: AnimateLogoProps;
  };
};

export function SplashScreen({
  portal = false,
  slots,
  slotProps,
  className,
  ...other
}: SplashScreenProps) {
  const logoSlotProps = {
    ...slotProps?.logo,
    slotProps: {
      ...slotProps?.logo?.slotProps,
      logo: {
        ...slotProps?.logo?.slotProps,
        isSingle: true,
      },
    },
  };

  const content = (
    <div
      className={twMerge('flex flex-col flex-grow', slotProps?.wrapper?.className)}
      {...slotProps?.wrapper}
    >
      <div
        className={twMerge(
          'fixed bg-white right-0 bottom-0 z-[9998] flex-grow w-full h-full flex items-center justify-center',
          className
        )}
        {...other}
      >
        {typeof document === 'undefined'
          ? (slots?.logo ?? <AnimateLogoZoomCSS {...logoSlotProps} />)
          : (slots?.logo ?? <AnimateLogoZoom {...logoSlotProps} />)}
      </div>
    </div>
  );

  if (portal && typeof document !== 'undefined') {
    return createPortal(content, document.body);
  }

  return content;
}
